export class ActionError {
  idActionError: number;
  idAction: number;
  name: string;
  orphan: boolean;

  constructor(
    idActionError: number,
    idAction: number,
    name: string,
    orphan: boolean,
  ) {
    this.idActionError = idActionError;
    this.idAction = idAction;
    this.name = name;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): ActionError {
    return new ActionError(
      Number(raw.idActionError),
      Number(raw.idAction),
      String(raw.name),
      Boolean(raw.orphan),
    );
  }

  clone(): ActionError {
    return new ActionError(
      this.idActionError,
      this.idAction,
      this.name,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idActionError: this.idActionError,
      idAction: this.idAction,
      name: this.name,
      orphan: this.orphan,
    };
  }
}
